import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YesNoDescriptionInput from '../YesNoDescriptionInput';
import './YesNoDescriptionInputGroup.scss';
var getValueField = function getValueField(option, value, field) {
  var optionValue = value && value.find(function (v) {
    return v.id === option.id;
  });
  return optionValue && optionValue[field];
};
var YesNoDescriptionInputGroup = /*#__PURE__*/function (_Component) {
  function YesNoDescriptionInputGroup(props) {
    var _this;
    _classCallCheck(this, YesNoDescriptionInputGroup);
    _this = _callSuper(this, YesNoDescriptionInputGroup, [props]);
    _this.renderOne = _this.renderOne.bind(_this);
    return _this;
  }
  _inherits(YesNoDescriptionInputGroup, _Component);
  return _createClass(YesNoDescriptionInputGroup, [{
    key: "renderOne",
    value: function renderOne(option, index) {
      var _this$props = this.props,
        value = _this$props.value,
        formKey = _this$props.formKey,
        errors = _this$props.errors,
        requiredDescriptionValues = _this$props.requiredDescriptionValues,
        exampleText = _this$props.exampleText,
        onAnswerChange = _this$props.onAnswerChange,
        textAreaPrompt = _this$props.textAreaPrompt;
      var selectedValue = getValueField(option, value, 'selected');
      var descValue = getValueField(option, value, 'desc');
      var descRequired = requiredDescriptionValues.indexOf(selectedValue) > -1 || selectedValue === null;
      var error = null;
      if ((!descValue || descValue.trim() === '' || descValue.trim().length < 50 && formKey === 'responsibility_areas') && descRequired) {
        error = errors["".concat(formKey, "_").concat(option.id)];
      }
      return /*#__PURE__*/React.createElement("div", {
        key: option.id
      }, /*#__PURE__*/React.createElement(YesNoDescriptionInput, {
        formKey: formKey,
        index: index,
        option: option,
        value: value,
        exampleText: exampleText,
        selectedValue: selectedValue,
        onAnswerChange: onAnswerChange,
        error: error,
        textAreaPrompt: textAreaPrompt
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var options = this.props.options;
      return /*#__PURE__*/React.createElement("div", {
        className: "yes-no-description-input-group"
      }, options.map(function (option, index) {
        return _this2.renderOne(option, index + 1);
      }));
    }
  }]);
}(Component);
YesNoDescriptionInputGroup.propTypes = {
  formKey: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    selected: PropTypes.string,
    desc: PropTypes.string
  })),
  onAnswerChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}),
  requiredDescriptionValues: PropTypes.arrayOf(PropTypes.string),
  exampleText: PropTypes.string,
  textAreaPrompt: PropTypes.string
};
YesNoDescriptionInputGroup.defaultProps = {
  value: [],
  errors: {},
  requiredDescriptionValues: [],
  exampleText: null,
  textAreaPrompt: 'Tell us more about that.'
};
export default YesNoDescriptionInputGroup;